app.service('wcToCartView', function () {
	function init(){

	}
	return {
		init: init
	};
});
